import { useQueryClient } from "@tanstack/react-query";
import { useFiltersV2Select } from "PFApp/components/filters_v2";
import { savedFiltersKeys } from "PFCore/hooks/queries/filters/query_keys";

export const useIsProcessingSavedFiltersCollections = () => {
  const queryClient = useQueryClient();
  const { collection } = useFiltersV2Select("collection");

  return (
    !!collection &&
    (queryClient.isFetching({ queryKey: savedFiltersKeys.target(collection) }) > 0 ||
      queryClient.isMutating({ mutationKey: savedFiltersKeys.all() }) > 0)
  );
};
